import React, { useState , useEffect} from 'react';
import { 
  Box, 
  Container, 
  Tabs, 
  Tab 
} from '@mui/material';

import MonitoringTab from '../components/MonitoringTab';
import DiskManagement from '../components/DiskManagement';
import VMOverview from '../components/VmOverview';
import NetworkingTab from '../components/NetworkTab';
import CloudPortalHeader from '../components/CloudPortaHeader';
import Layout from '../layout/layout';
import {api}from '../services/api';
import { useParams } from 'react-router-dom';
import TagTab from '../components/TagTab'; // Import the TagTab component

const Report = () => {
  const [tabValue, setTabValue] = useState(0);
  const [cpuData, setCpuData] = useState(null);
    const [tagData, setTagData] = useState(null);
    
  const [resourceData, setResourceData] = useState(null);

   const { resourceReqId } = useParams(); 
  //  const[vmData, setVmData] = useState(null);
const userId = sessionStorage.getItem('userId');
  const vmData = {
    name: 'production-vm-01',
    status: 'Running',
    size: 'Standard_D2s_v3',
    location: 'East US',
    uptime: '15 days, 4 hours',
    // publicIP: '20.185.123.45',
    // privateIP: '10.0.0.4'
  };

  const currentUsage = {
    cpu: 65,
    memory: 78,
    network: 45
  };

  useEffect(() => {
    const fetchCPUUtilization = async () => {
       if (!resourceReqId) {
        console.error('Resource Request ID is not provided');
        return;
      }
      try {
        const response = await api.get(`/Report/getCPUUtilization/${resourceReqId}?userId=${userId}`, {
          headers: {
            'accept': 'text/plain',
            'X-CORRELATION-ID': 'ae6b75ca-6251-49b0-b33e-9bfaa5b6b612'
          }
        });
       if (response.data.tags) {
        setTagData(response.data.tags); // Set the tags directly
      } else {
        console.error('Tags not found in the response');
      } // Log the full response
        setTagData(response.data);

       // setVmData(response.data);
        setCpuData(response.data.cPUUtlization);
      } catch (error) {
        console.error('Error fetching CPU utilization:', error);
      }
    };

    if (tabValue === 0) {
      fetchCPUUtilization();
       const intervalId = setInterval(fetchCPUUtilization, 3000); // Set up polling every 3 seconds

      return () => clearInterval(intervalId); // Clean up the interval on component unmount
    
    }
  }, [tabValue, resourceReqId]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
        <Layout pageType="sideBar">
    
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', p: 3,width:'100%' }}>
      <Box sx={{width:'100%'}}>
        {/* Header */}
        <CloudPortalHeader />

        {/* VM Overview */}
         {/* {resourceData && <VMOverview resource={resourceData} />} */}

        {resourceReqId && (
            <VMOverview 
              resource={{ 
                resourceId: resourceReqId,
                applicationName: 'VM Instance', // Optional: can be fetched from API
                status: 'Running' // Optional: can be fetched from API
              }} 
               />
          )}



         
        {/* <VMOverview vmData={vmData} currentUsage={currentUsage} /> */}

        {/* Main Content Tabs */}
        <Box sx={{ width: '100%', mt: 4 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Monitoring & Metrics" />
              <Tab label="Disk Management" />
              {/* <Tab label="Networking" /> */}
              <Tab label="Tags" />

            </Tabs>
          </Box>

          {/* Monitoring Tab */}
          {tabValue === 0 && (
            <MonitoringTab currentUsage={currentUsage} cpuData={cpuData}/>
          )}

          {/* Disk Management Tab */}
          {tabValue === 1 && (
            <Box sx={{ py: 3 }}>
              <DiskManagement />
            </Box>
          )}

          {/* Networking Tab */}
          {/* {tabValue === 2 && (
            <NetworkingTab vmData={vmData} />
          )} */}

{/* {tabValue === 3 && tagData && Object.keys(tagData).length > 0 && (
            // <TagTab tags={tagData.tags} />
              <TagTab tags={tagData.tags} />
          )} */}


          {tabValue === 2 && (
            // <TagTab tags={tagData.tags} />
            <Box sx={{ py: 3 }}>
               <TagTab  resource={{ 
                 resourceId: resourceReqId,}}/> 
              </Box>
          )}
        </Box>
      </Box>
    </Box>
    </Layout>
  );
};

export default Report;
